import { classNames } from '@panwds/tailwindcss';
import React, { useContext } from 'react';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { RadioGroupContext } from './RadioGroup.esm.js';
import { RadioInput } from './RadioInput.esm.js';

/**
 * A radio that can be used to build forms. Radios must be wrapped in a RadioGroup.
 */
function Radio(props) {
    const { checked, children, dataMetrics, dataTestId, disabled = false, readOnly = false, isError, value, ...rest } = props;
    const { disabled: groupDisabled, readOnly: groupReadOnly, name, onChange, ref, value: selectedValue } = useContext(RadioGroupContext);
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" && name === '') {
        throw new Error('Attempted to render Radio outside of a RadioGroup context or RadioGroup name is not set. Make sure your component is rendered inside <RadioGroup> with a name.');
    }
    const isDisabled = groupDisabled || disabled;
    const isReadOnly = groupReadOnly || readOnly;
    const checkedProps = {};
    if (checked !== undefined) {
        checkedProps.checked = checked;
    }
    else {
        checkedProps.defaultChecked = value === selectedValue;
    }
    return (React.createElement("label", { className: classNames('tw-font-lato tw-flex tw-items-center tw-text-xs tw-space-x-2 tw-w-max', isDisabled || isReadOnly ? 'tw-text-disabled tw-cursor-not-allowed' : 'tw-cursor-pointer') },
        React.createElement(RadioInput, { dataMetrics: dataMetrics, dataTestId: dataTestId || `${typeof value !== 'string' ? 'radio' : `radio-${testIdGen(value)}`}`, isError: isError, name: name, value: value, onChange: onChange, disabled: isDisabled, readOnly: isReadOnly, ref: ref, ...checkedProps, ...rest }),
        React.createElement("span", null, children)));
}

export { Radio };
//# sourceMappingURL=Radio.esm.js.map
